import { render, staticRenderFns } from "./email-distributions-view.vue?vue&type=template&id=cb344ed6"
import script from "./email-distributions-view.vue?vue&type=script&lang=js"
export * from "./email-distributions-view.vue?vue&type=script&lang=js"
import style0 from "./email-distributions-view.vue?vue&type=style&index=0&id=cb344ed6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports